import React from 'react';
import { Box, Grid, Typography, Tooltip } from '@mui/material';
import { AiFillEdit } from 'react-icons/ai';
import { StyledIconButton } from '../utils/StyleTable';
import { NOT_AVAILABLE } from '../pages/Global/Constants';

export default function ViewLargeCard({ title, fields = [], handleEdit, rowId }) {
  return (
    <Grid item xs={12} sm={6} md={6} mb={3}>
      <Typography variant="body1" className="headingLineUp headingLineUpOut">
        {title}
      </Typography>
      <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
        {handleEdit && (
          <Box className="extraTopIcon">
            <Tooltip
              title="Edit"
              placement="top"
              arrow
              onClick={() => handleEdit({ userId: rowId, action: 'edit' })}
            >
              <StyledIconButton className="squareIconButton squareIconButtonFilled">
                <AiFillEdit size={14} />
              </StyledIconButton>
            </Tooltip>
          </Box>
        )}
        <Grid container spacing={3}>
          {fields.map((field, index) => (
            <Grid item xs={4} key={index}>
              <Box className="displayFlex">
                {field.icon}
                <Box ml={1}>
                  <Typography variant="subtitle2" className="labelValue">
                    {field.label}
                  </Typography>
                  <Typography variant="body2" className="labelText ">
                    {field.value !== null && field.value !== undefined && field.value !== ''
                      ? field.value
                      : NOT_AVAILABLE}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>{' '}
    </Grid>
  );
}
